import store from "data/store";
import { Card, Flex, Spin } from "antd";
import React, { Component } from "react";
import { observer } from "mobx-react";
import withRouter from "hocs/withRouter";

import NavigationService from "services/navigation";

import Chat from "components/chat";
import Toolbar from "components/chat/toolbar";

class ChatPage extends Component {
  get chat() {
    return store.activeChat;
  }

  componentDidMount() {
    if (!this.chat) NavigationService.navigate(-1);
    this.chat?.markAllUnreadMessages();
    this.chat?.getEarlierMessages();
    this.chat?.contact.getNotes();
    this.chat?.contact.getPremiums();
    this.chat?.contact.getPhotos();
  }

  componentWillUnmount() {
    if (!this.chat) {
      NavigationService.navigate(-1);
    } else {
      this.chat.resetMessages();
      store.selectChat(undefined);
    }
  }

  render() {
    if (!this.chat) return <Spin fullscreen />;

    return (
      <Flex
        style={{ flex: 1, justifyContent: "flex-end" }}
        vertical
        offset={10}
      >
        <Card>
          <Toolbar chat={this.chat} />
        </Card>
        <Chat
          isTyping={this.chat.isTyping}
          getEarlierMessages={this.chat.getEarlierMessages}
          messages={this.chat.messages}
          onSubmit={this.chat.send}
          onEndTyping={this.chat.stopTyping}
          onStartTyping={this.chat.startTyping}
          tarots={store.tarots.items}
          consultantId={this.chat.consultant.id}
          premiums={this.chat.contact.premiumPurchases}
        />
      </Flex>
    );
  }
}

export default withRouter(observer(ChatPage));
